import { Loader2 } from "lucide-react";
import { forwardRef } from "react";
import styles from "./Button.module.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** `decline` is the soft counterpart of `danger`: the "no" of an ordinary
   *  decision (Reject a proposal), where `danger`'s full-strength outline is
   *  kept for destructive acts (Delete). Pair it with `success` for approve. */
  variant?: "primary" | "secondary" | "danger" | "decline" | "success" | "ghost";
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  icon?: React.ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "secondary",
      size = "sm",
      loading = false,
      icon,
      children,
      className,
      disabled,
      type = "button",
      ...rest
    },
    ref,
  ) => {
    const cls = [
      styles.btn,
      styles[variant],
      styles[size],
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <button
        ref={ref}
        type={type}
        className={cls}
        disabled={disabled || loading}
        {...rest}
      >
        {loading ? (
          <Loader2 size={14} className={styles.spinner} />
        ) : icon ? (
          icon
        ) : null}
        {children}
      </button>
    );
  },
);

Button.displayName = "Button";
